// The typefaces the designer offers, as plain ids. Safe to import anywhere, including server routes.
export const FONT_IDS = [
    'inter',
    'figtree',
    'montserrat',
    'space-grotesk',
    'bricolage',
    'archivo-black',
    'anton',
    'bebas',
    'dm-serif',
    'playfair',
    'fraunces',
    'caveat',
    'jetbrains'
] as const

const FONT_ID_SET = new Set<string>(FONT_IDS)

export const isFontId = (id: unknown): id is string => typeof id === 'string' && FONT_ID_SET.has(id)
